// Single source of truth for notification -> destination.
// Returns null when a type/role combination has no destination (click just marks read).
export function resolveNotificationRoute(notif, role) {
  const d = notif.data || {};
  if (d.link) return d.link;

  const isPrincipal = role === 'principal' || role === 'school_admin';
  const isTeacher = role === 'teacher';
  const isParent = role === 'parent';

  switch (notif.type) {
    case 'leave_request':
      return isPrincipal ? '/principal/leave-management' : null;
    case 'leave_approved':
    case 'leave_rejected':
      return isTeacher ? '/teacher/leave-management' : null;
    case 'leave_balance_updated':
      return isTeacher ? '/teacher/leave-management' : null;
    case 'holiday_created':
      return isTeacher ? '/teacher/holidays' : '/principal/holidays';
    case 'announcement_created':
      return isTeacher ? '/teacher/announcements' : '/principal/announcements';
    case 'exam_created':
    case 'class_assigned':
      return isTeacher ? '/teacher/classes' : null;
    case 'weekly_plan_submitted':
      return isPrincipal ? '/principal/weekly-reports' : null;
    case 'marks_submitted':
      return isPrincipal ? (d.class_id ? `/principal/view-marks?classId=${d.class_id}` : '/principal/view-marks') : null;
    case 'attendance_submitted':
      return isPrincipal ? '/principal/attendance' : null;
    case 'meeting_scheduled':
    case 'meeting_completed':
      return isPrincipal ? '/principal/parent-meetings' : null;
    case 'expense':
      return isPrincipal ? '/principal/expenses' : null;
    case 'low_stock_alert':
      return isPrincipal ? '/principal/inventory' : null;
    case 'parent_query':
      return isTeacher ? '/teacher/parent-queries' : null;
    case 'daycare_auto_checkout':
      return isTeacher ? '/teacher/daycare' : isPrincipal ? '/principal/daycare' : null;
    case 'inbox_message': {
      const base = isTeacher ? '/teacher/inbox' : isPrincipal ? '/principal/inbox' : null;
      return base && d.conversation_id ? `${base}?conversation=${d.conversation_id}` : base;
    }
    case 'staff_meeting_invite':
    case 'staff_meeting_updated':
    case 'staff_meeting_cancelled': {
      const base = isTeacher ? '/teacher/staff-calendar' : isPrincipal ? '/principal/staff-calendar' : null;
      return base && d.meeting_id ? `${base}?meeting=${d.meeting_id}` : base;
    }
    // Parent-facing
    case 'daily_update':
      return isParent && d.student_id ? `/parent/child/${d.student_id}` : null;
    case 'query_completed':
      return isParent ? '/parent/queries' : null;
    case 'care_note_completed':
      return isParent ? '/parent/care-notes' : null;
    default:
      return null;
  }
}
